import React from "react";
import "./Tooltip.css";
import { BsQuestionCircle } from "react-icons/bs";

const ToolTip = ({ children, ...props }) => {
  return (
    <div className={`${props.tooltipVisible ? "tooltip" : "hide-tooltip"} ${props.className || ''}`}>
      {children ?? <BsQuestionCircle size={12} />}
      <span className={`tooltiptext ${props.contentClassName}`}>
        {props.tooltipText || "Nenhuma descrição disponível"}
      </span>
    </div>
  );
};

export default ToolTip;
